/**
 * Action for date selection of wizard view of a reservation.
 *
 * @class
 */
Sitepackage.Plugin.Reservation.WizardStepDateSelectionAction = (function () {

    /**
     * Initializes the action.
     *
     * @param {Reservation} plugin Parent plugin
     * @param {Element} pluginContainer Parent plugin container
     * @param {Element} container Main container of the action
     *
     * @constructor
     */
    var WizardStepDateSelectionAction = function (plugin, pluginContainer, container) {
        const self = this;

        // Parent plugin
        self.plugin = plugin;

        // Parent plugin container
        self.pluginContainer = pluginContainer;

        // Main container of the action
        self.container = container;

        self.submitContainer = self.container.querySelector('.submit-row');

        self.contentContainer = self.container.querySelector('.step-content');

        this.reservationDataTemplate = this.container.querySelector('.reservation-data').cloneNode(true);
        this.reservationDataTemplate.classList.remove('reservation-data');

        self.lastSuggestedDate = new Date();


        self.templates = {
            'dateSelection': self.container.querySelector('.template-date-selection'),
            'dateSelectionDropdown': self.container.querySelector('.template-date-selection-dropdown'),
            'timeSelection': self.container.querySelector('.template-time-selection'),
            'errorTimeslot': self.container.querySelector('.template-error-timeslot')
        };

        self.plugin.listener.ticketChanged.push(function () {
            if (typeof self.container.dataset.dirty === 'undefined' || self.container.dataset.dirty === "1") {
                self.initialize();
            }
        });

        //self.initialize();
    };

    /**
     *
     * @param callback
     */
    WizardStepDateSelectionAction.prototype.initialize = function (callback) {
        const self = this;

        let currentValues = self.plugin.getCurrentValues();

        self.initialTimeslot = {};
        const containerCurrent = document.querySelector('.card[data-wizardstep="2"]');
        
        if (currentValues['timeslots'] && currentValues['timeslots'][self.container.dataset.timeslot]) {
            console.log("b");
            currentValues = currentValues['timeslots'][self.container.dataset.timeslot];
            self.initialTimeslot = {
                date: currentValues.date,
                time: currentValues.time
            };
        }

        self.hideHasDataHeader();
        GeneralUtility.hideLoadingAnimationOfCard(self.container);

        const timeslotArticle = self.container.dataset.timeslot;


        if (timeslotArticle && self.plugin.timeslotData && self.container.dataset.dirty === "1") {

            self.container.dataset.dirty = "0";
            self.timeslotData = self.plugin.timeslotData[timeslotArticle];

            if (self.timeslotData && Object.keys(self.timeslotData).length > 0) {
                self.contentContainer.innerHTML = self.templates['dateSelection'].innerHTML;
                self.initializeDatepicker(self.timeslotData);

                self.nextPossibleButton = self.contentContainer.querySelector('.btn-next-date');
                self.nextPossibleButton.classList.remove('d-none');
                self.initializeNextPossibleButton();
                self.initializeManualTimeInput();

                //Set title of timeslot article in card header if more than one timeslot have to be selected
                var selectedTicket = self.plugin.getCurrentValue('ticket');

                var parts = timeslotArticle.split('-');

                //Timeslots are accessible by article number (parts[0])
                self.container.dataset.timeslottitle = self.plugin.timeslotTickets[parts[0]];
                self.fillTimeslotTitle();
            } else {
                self.showErrorMessage('errorTimeslot');
            }
        } else {
            self.showErrorMessage('errorTimeslot');
        }

        self.prefill(function () {
            self.validateStep();

            if (callback && typeof callback === 'function') {
                callback();
            }
        });


    };

    WizardStepDateSelectionAction.prototype.isOpen = function () {
        return this.container.classList.contains('card-active');
    };

    WizardStepDateSelectionAction.prototype.prefill = function (callback) {
        const self = this;
        var currentValues = self.plugin.getCurrentValues();


        if (currentValues['timeslots'] && currentValues['timeslots'][self.container.dataset.timeslot]) {
            currentValues = currentValues['timeslots'][self.container.dataset.timeslot];
        }

        self.updateHasDataHeader();
        if (self.hasData() && !self.isOpen()) {
            self.showHasDataHeader();
        }

        if (currentValues.date) {
            if (this.contentContainer.querySelector('.ts-date')) {
                this.contentContainer.querySelector('.ts-date').value = this.convertToLocaleFormat(currentValues.date);
            }
            self.renderTimeslots(currentValues.date, function () {
                if (currentValues.time) {
                    var tsButton = self.contentContainer.querySelector('.ts-btn[data-time="' + currentValues.time + '"]');

                    //Button might not exists because admin user manually set a time
                    if (tsButton) {
                        tsButton.classList.add('active');
                    }
                }
            });

            /*if(self.nextPossibleButton) {
                self.nextPossibleButton.classList.add('d-none');
            }*/
        }


        if (callback && typeof callback === 'function') {
            callback();
        }
    };

    /**
     * Initialize events for the "Next possible timeslot" button
     */
    WizardStepDateSelectionAction.prototype.initializeNextPossibleButton = function () {
        const self = this;
        var btn = self.contentContainer.querySelector('.btn-next-date');
        if (btn) {
            var eventFunction = function (e) {
                //Search for next timeslot after now or previously suggested time.
                let start = new Date();
                start.setDate(start.getDate());
                if (self.lastSuggestedDate && self.lastSuggestedDate > start) {
                    start = self.lastSuggestedDate;
                }
                const currentValues = self.plugin.getCurrentValues();
                const totalPersons = currentValues.persons;

                let nextPossibleDay = '';
                let nextPossibleTime = '';
                let chosenDate = null;
                if (self.timeslotData) {
                    for (let day in self.timeslotData) {
                        if (self.timeslotData.hasOwnProperty(day)) {
                            const dateParts = day.split('-');
                            const currentDay = new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]), 0, 0);
                            //Only allow days in the future

                            if (currentDay > start) {
                                const timeslots = self.timeslotData[day];
                                timeslots.forEach(function (timeslot) {
                                    const timeParts = timeslot.time.split(':');
                                    const currentDate = new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]), parseInt(timeParts[0]), parseInt(timeParts[1]));


                                    if (nextPossibleDay === '' &&
                                        nextPossibleTime === '' &&
                                        timeslot.free >= totalPersons
                                    ) {
                                        chosenDate = currentDate;
                                        nextPossibleDay = day;
                                        nextPossibleTime = timeslot.time;
                                    }
                                });
                            }
                        }
                    }
                }
                if (nextPossibleDay !== '' && nextPossibleTime !== '') {
                    self.setCurrentDate(nextPossibleDay);
                    self.setCurrentTime(nextPossibleTime);
                    self.lastSuggestedDate = chosenDate;
                    const timeInput = self.contentContainer.querySelector('.ts-time');
                    if (timeInput) {
                        timeInput.value = nextPossibleTime;
                    }
                    self.prefill(function () {
                        self.validateStep();
                    });
                }
            };
            btn.removeEventListener('click', eventFunction);
            btn.addEventListener('click', eventFunction);
        }
    };

    /**
     * Initialize events for time input shown only if admin user is logged in
     */
    WizardStepDateSelectionAction.prototype.initializeManualTimeInput = function () {
        const self = this;
        var timeInput = self.contentContainer.querySelector('.ts-time');
        if (timeInput) {
            var eventFunction = function (e) {
                var value = timeInput.value;
                if (value.trim().length > 0) {
                    self.setCurrentTime(value);
                    var tsButton = self.contentContainer.querySelector('.ts-btn[data-time="' + value + '"]');
                    self.container.querySelectorAll('.ts-btn').forEach(function (item) {
                        item.classList.remove('active');
                    });

                    //if button with same time exists, set it active
                    if (tsButton) {

                        tsButton.classList.add('active');
                    }

                }
            };
            timeInput.removeEventListener('blur', eventFunction);
            timeInput.addEventListener('blur', eventFunction);
        }
    };

    WizardStepDateSelectionAction.prototype.convertToLocaleFormat = function (dateString) {
        var parts = dateString.split('-');
        if (parseInt(parts[1]) < 10 && parts[1].length === 1) {
            parts[1] = '0' + parts[1];
        }
        if (parseInt(parts[2]) < 10 && parts[2].length === 1) {
            parts[2] = '0' + parts[2];
        }
        if (parseInt(Globals.languageId) === 1) {
            return parts[0] + '/' + parts[1] + '/' + parts[2];
        }
        return parts[2] + '.' + parts[1] + '.' + parts[0];

    };

    /**
     *
     */
    WizardStepDateSelectionAction.prototype.initializeDatepicker = function (timeslots) {
        const self = this;

        var dateInput = this.contentContainer.querySelector('.ts-date');
        var firstDate = Object.keys(timeslots)[0];
        var firstDateObject = Date.parse(firstDate);
        var now = new Date();


        if (firstDateObject < now) {
            firstDate = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();
        }

        var lastDate = Object.keys(timeslots).pop();

        var lastDateObject = Date.parse(lastDate);
        if (lastDateObject < now) {
            lastDate = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();
        }


        firstDate = this.convertToLocaleFormat(firstDate);
        lastDate = this.convertToLocaleFormat(lastDate);
        var datepickerLanguage = 'de';
        if (parseInt(Globals.languageId) === 1) {
            datepickerLanguage = 'en';
        }

        var defaultDate = firstDate;
        var currentValues = self.plugin.getCurrentValues();

        if (currentValues['timeslots'] && currentValues['timeslots'][self.container.dataset.timeslot]) {
            currentValues = currentValues['timeslots'][self.container.dataset.timeslot];
            if (currentValues.date) {
                defaultDate = self.convertToLocaleFormat(currentValues.date);
            }
        }


        var datePicker = new Datepicker(dateInput, {
            autohide: true,
            container: 'body',

            buttonClass: 'btn',
            format: Globals.dateFormat,
            language: datepickerLanguage,
            prevArrow: Globals.iconPrevious,
            nextArrow: Globals.iconNext,
            minDate: firstDate,
            maxDate: lastDate,
            defaultViewDate: defaultDate,

            beforeShowDay: function (date) {
                var isSelectable, additionalClasses, htmlFragment;

                var d = date.getDate();
                if (d < 10) {
                    d = '0' + d;
                }
                var m = date.getMonth() + 1;
                if (m < 10) {
                    m = '0' + m;
                }
                var y = date.getFullYear();

                var dateKey = y + '-' + m + '-' + d;
                var hasTimeslots = (timeslots.hasOwnProperty(dateKey));

                var freeSlots = 0;
                if (hasTimeslots) {
                    var length = timeslots[dateKey].length;
                    for (var i = 0; i < length; i++) {
                        if (timeslots[dateKey][i].free > 0) {
                            freeSlots++;
                        }
                    }
                }

                var today = new Date();
                isSelectable = true;
                today.setHours(0, 0, 0, 0);
                additionalClasses = '';
                if (date >= today) {

                    if (freeSlots === 0) {
                        //additionalClasses = 'bg-danger';
                        isSelectable = false;
                    } else if (freeSlots <= 2) {
                        additionalClasses += ' status2';
                    } else {
                        additionalClasses += ' status1';
                    }
                } else {
                    isSelectable = false;
                }

                return {
                    enabled: isSelectable,
                    content: '<span class="day-cell-content ' + additionalClasses + '">' + date.getDate() + '</span>'
                };
            }
        });
        dateInput.addEventListener('changeDate', function (event) {
            var selectedDate = event.detail.date;
            var dateString = Datepicker.formatDate(selectedDate, 'yyyy-mm-dd');

            var currentDate = self.getCurrentDate();
            if (dateString != currentDate) {
                self.setCurrentDate(dateString);
                self.setCurrentTime('');

                self.renderTimeslots(dateString, function () {
                    self.submitContainer.classList.remove('d-none');
                });
            }

            //Hide next possible date button if the user chose a date manually
            /*if(self.nextPossibleButton) {
                self.nextPossibleButton.classList.add('d-none');
            }*/

        });

        GeneralUtility.addDatepickerCloseButton([datePicker]);
    };

    /**
     * Renders available timeslots for given date.
     *
     * @returns {boolean}
     */
    WizardStepDateSelectionAction.prototype.renderTimeslots = function (dateString, callback) {
        const self = this;

        var timeslots = self.timeslotData[dateString];
        var currentValues = self.plugin.getCurrentValues();
        if (timeslots) {

            this.contentContainer.querySelector('.time-selection').innerHTML = this.templates['timeSelection'].innerHTML;

            self.container.querySelectorAll('[data-toggle="tooltip"]').forEach(function (tooltip) {
                new Tooltip(tooltip);
            });

            var timeslotsHtml = '';
            var timeInput = self.contentContainer.querySelector('.ts-time');
            var isAdmin = false;
            if (timeInput) {
                isAdmin = true;
            }

            timeslots.forEach(function (item) {
                var classes = 'btn ts-btn';

                //Selected timeslot is always available when editing a reservation
                if (item.time === self.initialTimeslot.time && dateString === self.initialTimeslot.date) {

                    if (isAdmin) {
                        classes += ' ts-btn-status1';
                    }
                    timeslotsHtml += '<li>';
                    timeslotsHtml += '<button type="button" class="' + classes + '"';
                    timeslotsHtml += 'data-free="' + item.free + '"';
                    timeslotsHtml += 'data-time="' + item.time + '"';
                    timeslotsHtml += '>' + item.time + '</button>';
                    timeslotsHtml += '</li>';
                } else if (item.free <= 0) {

                    if (isAdmin) {
                        classes += ' ts-btn-status3';
                    }
                    timeslotsHtml += '<li>';
                    timeslotsHtml += '<button type="button" class="' + classes + '"';
                    timeslotsHtml += 'data-free="' + item.free + '"';
                    timeslotsHtml += 'data-time="' + item.time + '"';
                    timeslotsHtml += 'disabled>' + item.time + '</button>';
                    timeslotsHtml += '</li>';
                } else if (item.free < currentValues.persons) {
                    if (isAdmin) {
                        classes += ' ts-btn-status2';
                    }
                    timeslotsHtml += '<li>';
                    timeslotsHtml += '<button type="button" class="' + classes + '"';
                    timeslotsHtml += 'data-free="' + item.free + '"';
                    timeslotsHtml += 'data-time="' + item.time + '"';
                    timeslotsHtml += 'disabled>' + item.time + '<span class="ts-amount">' + item.free + '*</span></button>';
                    timeslotsHtml += '</li>';
                } else {
                    if (isAdmin) {
                        classes += ' ts-btn-status1';
                    }
                    timeslotsHtml += '<li>';
                    timeslotsHtml += '<button type="button" class="' + classes + '"';
                    timeslotsHtml += 'data-free="' + item.free + '"';
                    timeslotsHtml += 'data-time="' + item.time + '"';
                    timeslotsHtml += '>' + item.time + '</button>';
                    timeslotsHtml += '</li>';
                }
            });
            this.contentContainer.querySelector('.card-times UL').innerHTML = timeslotsHtml;

            self.container.querySelectorAll('.ts-btn').forEach(function (tsButton) {
                tsButton.addEventListener('click', function (e) {
                    self.container.querySelectorAll('.ts-btn').forEach(function (item2) {
                        item2.classList.remove('active');
                    });
                    tsButton.classList.add('active');
                    self.setCurrentTime(tsButton.dataset.time);
                    var timeInput = self.contentContainer.querySelector('.ts-time');
                    if (timeInput) {
                        timeInput.value = tsButton.dataset.time;
                    }
                    self.updateHasDataHeader();
                    self.validateStep();
                });

            });
        } else {
            self.showErrorMessage('errorTimeslot');
        }
        if (callback && typeof callback === 'function') {
            callback();
        }
    };

    /**
     * Get currently selected date

     * @returns {string}
     */
    WizardStepDateSelectionAction.prototype.getCurrentDate = function () {
        const self = this;
        var currentValues = self.plugin.getCurrentValues();
        if (!currentValues['timeslots']) {
            currentValues['timeslots'] = {};
        }
        if (!currentValues['timeslots'][self.container.dataset.timeslot]) {
            currentValues['timeslots'][self.container.dataset.timeslot] = {}
        }
        ;
        return currentValues['timeslots'][self.container.dataset.timeslot]['date'];
    };

    /**
     * Set given date string to the correct index in the currentValues object
     *
     * @param {string} date
     * @returns {void}
     */
    WizardStepDateSelectionAction.prototype.setCurrentDate = function (date) {
        const self = this;
        var currentValues = self.plugin.getCurrentValues();
        if (!currentValues['timeslots']) {
            currentValues['timeslots'] = {};
        }
        if (!currentValues['timeslots'][self.container.dataset.timeslot]) {
            currentValues['timeslots'][self.container.dataset.timeslot] = {}
        }
        ;
        currentValues['timeslots'][self.container.dataset.timeslot]['date'] = date;
        self.plugin.setCurrentValue('timeslots', currentValues['timeslots']);
    };

    /**
     * Set given time string to the correct index in the currentValues object
     *
     * @param {string} time
     * @returns {void}
     */
    WizardStepDateSelectionAction.prototype.setCurrentTime = function (time) {
        const self = this;
        var currentValues = self.plugin.getCurrentValues();
        if (!currentValues['timeslots']) {
            currentValues['timeslots'] = {};
        }
        if (!currentValues['timeslots'][self.container.dataset.timeslot]) {
            currentValues['timeslots'][self.container.dataset.timeslot] = {}
        }
        currentValues['timeslots'][self.container.dataset.timeslot]['time'] = time;

        self.plugin.setCurrentValue('timeslots', currentValues['timeslots']);
    };

    /**
     * Does pre submit tasks and calls callback function afterwards
     *
     * @returns {void}
     */
    WizardStepDateSelectionAction.prototype.preSubmit = function (callback) {
        if (callback && typeof callback === 'function') {
            callback();
        }
    };


    /**
     * Enables next button if all fields are filled correctly
     *
     * @returns {boolean}
     */
    WizardStepDateSelectionAction.prototype.validateStep = function () {
        const self = this;
        var valid = true;
        var timeInput = self.contentContainer.querySelector('.ts-time');
        var isAdmin = false;
        if (timeInput) {
            isAdmin = true;
        }
        if (isAdmin) {
            self.setValidState(true);
            self.submitContainer.classList.remove('d-none');
            self.submitContainer.querySelector('.btn-next').removeAttribute('disabled');
            self.plugin.toggleStateOfSubmitButton();
            return;
        }

        var currentValues = self.plugin.getCurrentValues();

        if (currentValues['timeslots'] && currentValues['timeslots'][self.container.dataset.timeslot]) {
            currentValues = currentValues['timeslots'][self.container.dataset.timeslot];
            if (!currentValues.date) {
                valid = false;
                self.plugin.showError(self.container.dataset.timeslot + '|date', TYPO3.lang['reservation.wizard.error.timeslot.noDate']);
            } else {
                self.plugin.removeError(self.container.dataset.timeslot + '|date');
            }
            if (!currentValues.time) {
                valid = false;
                self.plugin.showError(self.container.dataset.timeslot + '|time', TYPO3.lang['reservation.wizard.error.timeslot.noTimeslot']);
            } else {
                self.plugin.removeError(self.container.dataset.timeslot + '|time');
            }

            if (currentValues.date && currentValues.time) {

                if (!isAdmin) {
                    var totalPersons = self.plugin.getCurrentValue('persons');
                    if (self.timeslotData[currentValues.date]) {
                        var tsFound = false;


                        self.timeslotData[currentValues.date].forEach(function (item) {

                            if (item.time === currentValues.time) {
                                tsFound = true;
                                if (parseInt(item.free) < totalPersons && item.time !== self.initialTimeslot.time && currentValues.date !== self.initialTimeslot.date) {
                                    valid = false;
                                    self.plugin.showError(self.container.dataset.timeslot + '|date', TYPO3.lang['reservation.wizard.error.timeslot.invalidPersons']);
                                }
                            }
                        });
                        if (!tsFound) {
                            valid = false;
                            self.plugin.showError(self.container.dataset.timeslot + '|date', TYPO3.lang['reservation.wizard.error.timeslot.invalid']);
                        }
                    } else {
                        valid = false;
                        self.plugin.showError(self.container.dataset.timeslot + '|date', TYPO3.lang['reservation.wizard.error.timeslot.invalid']);
                    }
                }
            }
        } else {
            valid = false;
        }


        if (!valid) {
            self.submitContainer.querySelector('.btn-next').setAttribute('disabled', 'disabled');
        } else {
            self.submitContainer.classList.remove('d-none');
            self.submitContainer.querySelector('.btn-next').removeAttribute('disabled');
        }


        self.setValidState(valid);
        self.plugin.toggleStateOfSubmitButton();


        return valid;
    };

    /**
     * Shows given error message template
     *
     * @returns {void}
     */
    WizardStepDateSelectionAction.prototype.showErrorMessage = function (key) {
        const dateInput = this.contentContainer.querySelector('.ts-date');
        let errorMessageContainer;
        if (dateInput && dateInput.value) {
            errorMessageContainer = this.contentContainer.querySelector('.time-selection');
        }
        if (!errorMessageContainer) {
            errorMessageContainer = this.contentContainer;
        }
        errorMessageContainer.innerHTML = this.templates[key].innerHTML;
        if (dateInput && dateInput.value) {
            errorMessageContainer.classList.add('mt-3');
        } else {
            errorMessageContainer.classList.remove('mt-3');
        }
    };

    /**
     *
     * @param valid
     */
    WizardStepDateSelectionAction.prototype.setValidState = function (valid) {
        this.isValid = valid;
        this.container.dataset.valid = valid;
    };

    /**
     *
     * @returns {boolean}
     */
    WizardStepDateSelectionAction.prototype.getValidState = function () {
        return this.isValid;
    };

    /**
     *
     * Indicates if data was entered in the step. Used to modify the card header
     *
     * @returns {boolean}
     */
    WizardStepDateSelectionAction.prototype.hasData = function () {
        var currentValues = this.plugin.getCurrentValues();
        if (currentValues['timeslots'] && currentValues['timeslots'][this.container.dataset.timeslot]) {
            currentValues = currentValues['timeslots'][this.container.dataset.timeslot];
            if (currentValues.date || currentValues.time) {
                return true;
            }
        }
        return false;
    };

    /**
     *
     * Hides entered data and shows the generic headline again
     *
     * @returns {void}
     */
    WizardStepDateSelectionAction.prototype.hideHasDataHeader = function () {
        this.container.classList.remove('card-data');

    };

    /**
     *
     * Modifies the card header.
     *
     * @returns {void}
     */
    WizardStepDateSelectionAction.prototype.updateHasDataHeader = function () {
        var currentValues = this.plugin.getCurrentValues();
        var dataContainer = this.container.querySelector('.card-header .reservation-data');

        if (this.hasData()) {
            currentValues = currentValues['timeslots'][this.container.dataset.timeslot];
            var template = this.reservationDataTemplate.innerHTML;


            var date = Datepicker.parseDate(currentValues.date, 'yyyy-mm-dd');
            var format = 'D, dd.mm.yyyy';
            var lang = 'de';
            if (parseInt(Globals.languageId) === 1) {
                lang = 'en';
                format = 'D, mm/dd/yyyy';
            }
            var time = currentValues.time;
            if (!time) {
                time = '';
            } else if (parseInt(Globals.languageId) === 0) {
                time += ' Uhr';
            }


            var dateString = Datepicker.formatDate(date, format, lang);
            template = template.replace(/---field:date---/g, dateString);
            template = template.replace(/---field:time---/g, time);
            dataContainer.innerHTML = template;
            dataContainer.querySelector('[data-field-value="date"]').innerHTML = dateString;
            dataContainer.querySelector('[data-field-value="time"]').innerHTML = time;
            this.fillTimeslotTitle();

        }

    };

    /**
     *
     * Shows the card header. Shows entered data instead of the generic headline
     *
     * @returns {void}
     */
    WizardStepDateSelectionAction.prototype.showHasDataHeader = function () {
        if (this.hasData()) {
            this.container.classList.add('card-data');
        } else {
            this.container.classList.remove('card-data');
        }
    };

    /**
     *
     * Fills all timeslot title element with the title of the current timeslot stored in a data attribute of the container
     *
     * @returns {void}
     */
    WizardStepDateSelectionAction.prototype.fillTimeslotTitle = function () {
        const self = this;

        //Only show timeslot title if more than one timeslot is to be selected
        if (self.pluginContainer.querySelectorAll('.card[data-stepaction="date-selection"]').length > 1) {
            self.container.querySelectorAll('.timeslot-title').forEach(function (item) {
                if (self.container.dataset.timeslottitle && self.container.dataset.timeslottitle !== 'undefined') {
                    item.innerHTML = self.container.dataset.timeslottitle;
                } else {
                    item.innerHTML = '';
                }
            });
        } else {
            self.container.querySelectorAll('.timeslot-title').forEach(function (item) {
                item.innerHTML = '';
            });
        }
    };

    return WizardStepDateSelectionAction;
})();
